var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCityPin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.38632 1.72253C8.13644 1.47257 7.7975 1.33211 7.44406 1.33203H2.66479C2.31132 1.33203 1.97233 1.47245 1.72239 1.72239C1.47245 1.97233 1.33203 2.31132 1.33203 2.66479V7.44406C1.33211 7.7975 1.47257 8.13644 1.72253 8.38632L7.52269 14.1865C7.82557 14.4875 8.23522 14.6564 8.6622 14.6564C9.08919 14.6564 9.49883 14.4875 9.80171 14.1865L14.1865 9.80171C14.4875 9.49883 14.6564 9.08919 14.6564 8.6622C14.6564 8.23522 14.4875 7.82557 14.1865 7.52269L8.38632 1.72253Z",
    stroke: "#737373",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.99725 5.33044C5.18127 5.33044 5.33044 5.18127 5.33044 4.99725C5.33044 4.81324 5.18127 4.66406 4.99725 4.66406C4.81324 4.66406 4.66406 4.81324 4.66406 4.99725C4.66406 5.18127 4.81324 5.33044 4.99725 5.33044Z",
    fill: "#737373",
    stroke: "#737373",
    strokeWidth: 1.33276,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCityPin);
export default __webpack_public_path__ + "static/media/city_pin.29e8d89d8d2f669eb8a4f09c400c5855.svg";
export { ForwardRef as ReactComponent };